module.exports = __webpack_public_path__ + "res/img_business_view_bg.f2bdfecd119e1b7b8f1553f84ec6fdff.png";